// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"dY-z","sponsoredTooltipWrapper":"eY-z","sponsoredTooltip":"fY-z","newCard":"gY-z"};